import { Feed, getPersonFullName } from '@mntn-dev/ui-components'
import { ActivityTrans } from '../activity-trans.tsx'
import type { ActivityDetailsProps } from './types.ts'

export const ProjectOfferExpired = ({
  activity: {
    person,
    details: {
      activityType,
      data: { offer },
    },
  },
  t,
}: ActivityDetailsProps<'project_offer_expired'>) =>
  person && (
    <>
      <Feed.Summary>
        <ActivityTrans
          t={t}
          i18nKey={`${activityType}.summary`}
          values={{
            subject: getPersonFullName(person),
            offer,
          }}
        />
      </Feed.Summary>
      <Feed.Annotations>
        <Feed.Tag type="default">{t(`${activityType}.status`)}</Feed.Tag>
      </Feed.Annotations>
    </>
  )
